import api from "./client";


export const apiGet = (...args) => api.get(...args);
export const apiPost = (...args) => api.post(...args);
export const apiPut = (...args) => api.put(...args);
export const apiPatch = (...args) => api.patch(...args);
export const apiDelete = (...args) => api.delete(...args);
